export const REPORT_EMAIL = "contact@trescend.app";

export const reportContent = ({ type, id, ownerId }) => {
  const subject = encodeURIComponent(`Report: ${type} ${id}`);
  const body = encodeURIComponent(
    `I want to report this ${type}.\n\nType: ${type}\nID: ${id}\nOwner ID: ${ownerId}\n\nReason:\n`
  );
  window.location.href = `mailto:${REPORT_EMAIL}?subject=${subject}&body=${body}`;
};